import api from "@/services/api";
import { makeAutoObservable } from "mobx";

export class OrderStore {
    autocompleteProviders: string[] = [];
    selectedOrderDocketNumber: string | null = null;

    constructor() {
        makeAutoObservable(this);
    }

    public setOrderDocketNumber(docket: string) {
        this.selectedOrderDocketNumber = docket;
    }

    public searchProviders = async (name: string) => {
        var response = await api.autocompleteProviders(name);
        this.autocompleteProviders = response.data.result;
    };
}

const orderStore = new OrderStore();
export default orderStore;
